import classNames from "classnames";
import { ReactNode } from "react";
import style from "./Chip.module.scss";

export enum ChipColor {
  Blue = "blue",
  Green = "green",
  Orange = "orange",
  Red = "red",
  Gray = "gray",
}

export type ChipProps = {
  label: string;
  color: ChipColor;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  className?: string;
};

export function Chip({
  label,
  color = ChipColor.Blue,
  iconLeft,
  iconRight,
  className,
}: ChipProps) {
  return (
    <div className={classNames(style.wrapper, style[color], className)}>
      <div className={style.label}>
        {iconLeft && <span className={style.icon}>{iconLeft}</span>}
        <span>{label}</span>
        {iconRight && <span className={style.icon}>{iconRight}</span>}
      </div>
    </div>
  );
}
